var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcKakaotalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.5C17.6272 7.5 19.1323 7.8238 20.5151 8.47141C21.8979 9.11902 22.9911 9.99965 23.7946 11.1133C24.5982 12.2268 25 13.4415 25 14.7573C25 16.0731 24.5982 17.2895 23.7946 18.4066C22.9911 19.5236 21.8995 20.4059 20.5201 21.0535C19.1406 21.7011 17.6339 22.0249 16 22.0249C15.4844 22.0249 14.952 21.9872 14.4029 21.9119C12.019 23.6045 10.75 24.4612 10.596 24.4817C10.5223 24.5092 10.452 24.5057 10.385 24.4715C10.3582 24.4509 10.3382 24.4235 10.3248 24.3892C10.3114 24.3549 10.3047 24.3241 10.3047 24.2967V24.2556C10.3449 23.9883 10.6495 22.8747 11.2188 20.9148C9.92634 20.2569 8.90011 19.3848 8.14007 18.2986C7.38002 17.2124 7 16.032 7 14.7573C7 13.4415 7.40179 12.2268 8.20536 11.1133C9.00893 9.99965 10.1021 9.11902 11.4849 8.47141C12.8677 7.8238 14.3728 7.5 16 7.5Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKakaotalk);
export default __webpack_public_path__ + "static/media/ic_kakaotalk.e3d95e3da4a684a430d3d5762b5d0c24.svg";
export { ForwardRef as ReactComponent };